/**
 * Pending-review UI: tracked "Customer" / "Vendor" rows sometimes store a long
 * sentence; show only the resolved party name next to struck-through "empty".
 */
export function shortenTrackedPartyChangeNewValue(newText: string): string {
  const t = (newText || "").trim();
  const customer =
    /^Created a new customer with the name:\s*(.+)$/i.exec(t);
  if (customer) return customer[1].trim();
  const vendor = /^Created a new vendor with the name:\s*(.+)$/i.exec(t);
  if (vendor) return vendor[1].trim();
  return t;
}
